/* ------------------------------------------ Pick link goto AJAX CART - Hải 11.09.2018 ----------------------------------------- */
(function (jQuery) {
  jQuery.gfAjaxCartOptiops = function (element, options) {
    const defaults = {
      title: '',
      onSelected: function () {},
    };

    this.settings = {};
    const $element = $(element);

    const _this = this;
    let _name = '';

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      _name = $element.attr('name');
      switch (_name) {
        case 'cbTo':
          _this.callBackGoTo();
          break;
      }
      return false;
    };

    this.callBackGoTo = function () {
      $element.gfSegment({
        title: _this.settings.title,
        onSelected: function (value) {},
      });
    };

    this.init();
  };
  jQuery.fn.gfAjaxCartOptiops = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfajaxcartoptiops')) {
        const plugin = new jQuery.gfAjaxCartOptiops(this, options);
        jQuery(this).data('gfajaxcartoptiops', plugin);
      }
    });
  };
})(jQuery);
